import { PerformancePersonalReviewStatusEnum } from '../enums/performance-personal-review-status.enum';
import { IPerformancePersonalReviewStatus } from '../interfaces/performance-personal-review-status.interface';

// @dynamic
export class PerformancePersonalReviewStatus {
    static all: IPerformancePersonalReviewStatus[] = [
        {
            name: PerformancePersonalReviewStatusEnum.INPUT,
            translationLabel: 'PERFORMANCE_REVIEW.STATUS.INPUT',
            color: '#464B54',
            bgColor: '#FBE78D',
            svgIcon: 'personal_review_input',
            svgIconColor: '#F3AD3E',
        },
        {
            name: PerformancePersonalReviewStatusEnum.DISCUSSION,
            translationLabel: 'PERFORMANCE_REVIEW.STATUS.DISCUSSION',
            color: '#464B54',
            bgColor: '#A3CAEA',
            svgIcon: 'personal_review_discussion',
            svgIconColor: '#578DBF',
        },
        {
            name: PerformancePersonalReviewStatusEnum.REVIEW,
            translationLabel: 'PERFORMANCE_REVIEW.STATUS.REVIEW',
            color: '#464B54',
            bgColor: '#F1C7E3',
            svgIcon: 'personal_review_review',
            svgIconColor: '#F3AD3E',
        },
        {
            name: PerformancePersonalReviewStatusEnum.COMPLETED,
            translationLabel: 'PERFORMANCE_REVIEW.STATUS.COMPLETED',
            color: '#464B54',
            bgColor: '#D5E1A4',
            svgIcon: 'personal_review_completed',
            svgIconColor: '#95AF3F',
        },
        {
            name: PerformancePersonalReviewStatusEnum.CANCELED,
            translationLabel: 'PERFORMANCE_REVIEW.STATUS.CANCELED',
            color: '#464B54',
            bgColor: ' #FECACA',
            svgIcon: 'personal_review_canceled',
            svgIconColor: '#B91C1C',
        },
    ];
}
